/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetMcpServerUsageImpactSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetMcpServerUsageImpactSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetMcpServerUsageImpactSecurity = {
  option1?: GetMcpServerUsageImpactSecurityOption1 | undefined;
  option2?: GetMcpServerUsageImpactSecurityOption2 | undefined;
};

export type GetMcpServerUsageImpactRequest = {
  /**
   * The ID of the MCP server
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetMcpServerUsageImpactSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetMcpServerUsageImpactSecurityOption1$outboundSchema:
  z.ZodMiniType<
    GetMcpServerUsageImpactSecurityOption1$Outbound,
    GetMcpServerUsageImpactSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getMcpServerUsageImpactSecurityOption1ToJSON(
  getMcpServerUsageImpactSecurityOption1:
    GetMcpServerUsageImpactSecurityOption1,
): string {
  return JSON.stringify(
    GetMcpServerUsageImpactSecurityOption1$outboundSchema.parse(
      getMcpServerUsageImpactSecurityOption1,
    ),
  );
}

/** @internal */
export type GetMcpServerUsageImpactSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetMcpServerUsageImpactSecurityOption2$outboundSchema:
  z.ZodMiniType<
    GetMcpServerUsageImpactSecurityOption2$Outbound,
    GetMcpServerUsageImpactSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function getMcpServerUsageImpactSecurityOption2ToJSON(
  getMcpServerUsageImpactSecurityOption2:
    GetMcpServerUsageImpactSecurityOption2,
): string {
  return JSON.stringify(
    GetMcpServerUsageImpactSecurityOption2$outboundSchema.parse(
      getMcpServerUsageImpactSecurityOption2,
    ),
  );
}

/** @internal */
export type GetMcpServerUsageImpactSecurity$Outbound = {
  Option1?: GetMcpServerUsageImpactSecurityOption1$Outbound | undefined;
  Option2?: GetMcpServerUsageImpactSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetMcpServerUsageImpactSecurity$outboundSchema: z.ZodMiniType<
  GetMcpServerUsageImpactSecurity$Outbound,
  GetMcpServerUsageImpactSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetMcpServerUsageImpactSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetMcpServerUsageImpactSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getMcpServerUsageImpactSecurityToJSON(
  getMcpServerUsageImpactSecurity: GetMcpServerUsageImpactSecurity,
): string {
  return JSON.stringify(
    GetMcpServerUsageImpactSecurity$outboundSchema.parse(
      getMcpServerUsageImpactSecurity,
    ),
  );
}

/** @internal */
export type GetMcpServerUsageImpactRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetMcpServerUsageImpactRequest$outboundSchema: z.ZodMiniType<
  GetMcpServerUsageImpactRequest$Outbound,
  GetMcpServerUsageImpactRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function getMcpServerUsageImpactRequestToJSON(
  getMcpServerUsageImpactRequest: GetMcpServerUsageImpactRequest,
): string {
  return JSON.stringify(
    GetMcpServerUsageImpactRequest$outboundSchema.parse(
      getMcpServerUsageImpactRequest,
    ),
  );
}
